import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'tipos_servicos'


async function getTiposServicos() {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}`, { 'limit': 10000 });
        return data;
    } catch (e) {
        throw e;
    }
}

export const TipoServicoService = {
    getTiposServicos
}